/* BLACK CLAW predictive search v4.
   1) /search/suggest returns HTTP 417 for this store's locale (platform-level,
      cannot be fixed theme-side, confirmed in real browser).
   2) The regular /search route is not affected, so getSearchResults() fetches
      /search?q=...&type=product&options[prefix]=last&section_id=bc-search-quick-results
      and renders real products (sections/bc-search-quick-results.liquid).
   3) On failure the drawer stays open and untouched.
   4) 250ms debounce to avoid firing on every keystroke.
   5) The native #predictive-search results panel is display:none until
      .open() is called. .open() is also called on input focus when the field
      is still empty, so the popular-category chips (default state) are
      visible immediately when the search overlay opens.
   6) v4: options[prefix]=last enables partial/prefix word matching (e.g.
      "nec" -> Necklace products), matching the behaviour of the native
      predictive-search form, which already ships a hidden
      options[prefix]=last field for the same reason. Without this the
      regular /search route only matches whole tokens. */
(function () {
  function patch(PredictiveSearchProto) {
    if (!PredictiveSearchProto || PredictiveSearchProto.__bcPatchedV2) return;
    PredictiveSearchProto.__bcPatchedV2 = true;

    PredictiveSearchProto.getSearchResults = function (searchTerm) {
      var self = this;

      if (this.__bcDebounce) {
        clearTimeout(this.__bcDebounce);
        this.__bcDebounce = null;
      }

      if (!searchTerm) return;

      this.__bcDebounce = setTimeout(function () {
        var searchObj = { 'q': searchTerm, 'type': 'product' };
        var params = self.paramUrl(searchObj);

        fetch(theme.routes.search + '?' + params + '&options%5Bprefix%5D=last&section_id=bc-search-quick-results')
          .then(function (response) {
            if (!response.ok) throw new Error(response.status);
            return response.text();
          })
          .then(function (text) {
            var doc = new DOMParser().parseFromString(text, 'text/html');
            var resultsEl = doc.getElementById('shopify-section-bc-search-quick-results') || doc.getElementById('bc-search-quick-results');
            if (!resultsEl) return;

            self.predictiveSearchResults.innerHTML = resultsEl.innerHTML;
            self.open();

            if (window.AOS && typeof AOS.refreshHard === 'function') AOS.refreshHard();
          })
          .catch(function () {
          });
      }, 250);
    };
  }

  function attachDefaultOpen(psEl) {
    if (!psEl || psEl.__bcDefaultOpenAttached) return;
    psEl.__bcDefaultOpenAttached = true;

    var input = psEl.querySelector('input[type="search"]');
    if (!input) return;

    var reveal = function () {
      if (!input.value && typeof psEl.open === 'function') {
        psEl.open();
      }
    };

    input.addEventListener('focus', reveal);

    if (document.activeElement === input) reveal();
  }

  function init() {
    var els = document.querySelectorAll('predictive-search');
    if (els.length) {
      els.forEach(function (el) {
        if (el.constructor) patch(el.constructor.prototype);
        attachDefaultOpen(el);
      });
    } else {
      var tries = 0;
      var timer = setInterval(function () {
        tries++;
        var els2 = document.querySelectorAll('predictive-search');
        if (els2.length) {
          els2.forEach(function (el) {
            if (el.constructor) patch(el.constructor.prototype);
            attachDefaultOpen(el);
          });
          clearInterval(timer);
        } else if (tries > 20) {
          clearInterval(timer);
        }
      }, 100);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
